<template>
  <empty-state
    :image="emptyStateImage"
    :title="$t('redemption-history-no-items.title')"
    :message="$t('redemption-history-no-items.paragraph-1')"
  >
    <template #message>
      <i18n
        path="redemption-history-no-items.paragraph-2"
        tag="p"
      >
        <router-link :to="{ name: catalogRoute }">
          {{
            $t('redemption-history-no-items.link-text')
          }}
        </router-link>.
      </i18n>
    </template>
  </empty-state>
</template>
<script>
import { CATALOG_ROUTE } from '@/router/routes/route-names'
import emptyStateImage from '../../assets/images/your-rewards-ftue.svg'
import EmptyState from '@/components/shared/EmptyState'

export default {
  name: 'NoRedeemedItems',
  components: { EmptyState },
  computed: {
    catalogRoute () {
      return CATALOG_ROUTE
    },
    emptyStateImage () {
      return emptyStateImage
    }
  }
}
</script>
<style lang="scss" scoped>
.img-wrapper {
  margin: 24px 0;
  min-height: 300px;
}
</style>
